import { render } from "./DataSuami.vue?vue&type=template&id=883ec220"
import script from "./DataSuami.vue?vue&type=script&lang=js"
export * from "./DataSuami.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__